import { createBrowserApp } from "@visactor/vrender-core/entries/browser";

import { bootstrapVRenderSharedBrowserApp } from "./bootstrap-browser";

import { installPendingRuntimeContributionModulesToApp } from "./runtime-contribution";

import { acquireSharedApp, getSharedApp, releaseSharedApp } from "./shared-registry";

const SHARED_BROWSER_REGISTRY_ENV = "browser-shared";

function createSharedBrowserApp(options) {
    const {envParams: envParams} = options, entryOptions = Object.assign({}, options);
    delete entryOptions.env, delete entryOptions.envParams, delete entryOptions.key;
    const app = bootstrapVRenderSharedBrowserApp(createBrowserApp(entryOptions), envParams);
    return installPendingRuntimeContributionModulesToApp(app), app;
}

export function acquireSharedBrowserVRenderApp(options = {}) {
    return acquireSharedApp("browser-shared", options, createSharedBrowserApp, "browser");
}

export function getSharedBrowserVRenderApp(key) {
    return getSharedApp("browser-shared", key);
}

export function releaseSharedBrowserVRenderApp(key) {
    releaseSharedApp("browser-shared", key);
}

export { acquireSharedBrowserVRenderApp as acquireSharedVRenderApp, getSharedBrowserVRenderApp as getSharedVRenderApp, releaseSharedBrowserVRenderApp as releaseSharedVRenderApp };
//# sourceMappingURL=shared-browser.js.map